import React, { useEffect, useState } from 'react';
import { 
    Dialog, 
    DialogContent, 
    DialogTitle, 
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    CircularProgress,
    Chip,
    Tooltip,
    IconButton,
    Collapse
} from "@mui/material";
import { 
    CheckCircle as CheckCircleIcon,
    Error as ErrorIcon,
    Schedule as ScheduleIcon,
    KeyboardArrowDown as KeyboardArrowDownIcon,
    KeyboardArrowUp as KeyboardArrowUpIcon
} from '@mui/icons-material';
import productService from '../../../../services/productService';

const statusConfig = {
    2: { icon: ScheduleIcon, color: "warning", label: "Kontrol ediliyor" },
    1: { icon: CheckCircleIcon, color: "success", label: "Başarılı bir şekilde eklendi" },
    3: { icon: CheckCircleIcon, color: "success", label: "Başarılı bir şekilde güncellendi" },
    9: { icon: ErrorIcon, color: "error", label: "Ekleme sırasında hata meydana geldi" }
};
const TransferRow = ({ transfer }) => {
    const [open, setOpen] = useState(false);
    
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString('tr-TR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell>
                    <IconButton
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>


{transfer.marketPlace!=null?
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {transfer.marketPlace?.iconLink && (
            <img
                src={transfer.marketPlace.iconLink}
                alt={transfer.marketPlace.name}
                style={{ width: 24, height: 24, objectFit: 'contain' }}
            />
        )}
        {transfer.marketPlace?.name}
    </Box>:

<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
{transfer.ecommercePlace?.iconLink && (
    <img
        src={transfer.ecommercePlace.iconLink}
        alt={transfer.ecommercePlace.name}
        style={{ width: 24, height: 24, objectFit: 'contain' }}
    />
)}
{transfer.ecommercePlace?.name}
</Box>
}

                </TableCell>
                <TableCell>
                    <Chip
                       
                        label={statusConfig[transfer.status]?.label}
                        color={statusConfig[transfer.status]?.color}
                        size="small"
                    />
                </TableCell>
                <TableCell>{formatDate(transfer.createDate)}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <Typography variant="subtitle2" gutterBottom component="div">
                                Detaylar
                            </Typography>
                            <Box sx={{ 
                                display: 'grid', 
                                gridTemplateColumns: '1fr 1fr',
                                gap: 2,
                                mb: 2
                            }}>
                                <Paper variant="outlined" sx={{ p: 1, bgcolor: 'grey.50' }}>
                                 
                                    <Typography variant="body2">
                                        {transfer.userDescription}
                                    </Typography>
                                </Paper>
                            </Box>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

const ProductTransferInfoModal = ({ openInfoModal, handleClose, productId }) => {
    const [productTransfers, setProductTransfers] = useState(null);

    const getProductTransfer = async () => {
        try {
            const response = await productService.getProductTransfer(productId);
            setProductTransfers(response?.data?.data?.data);
        } catch (error) {
            console.error("Error fetching product transfers:", error);
        }
    };

    useEffect(() => {
        if (openInfoModal) {
            getProductTransfer();
        }
    }, [openInfoModal]);

    console.log("productTransfers",productTransfers);
    return (
        <Dialog 
            open={openInfoModal} 
            onClose={handleClose} 
            maxWidth="lg" 
            fullWidth
        >
            <DialogTitle sx={{
                bgcolor: 'grey.100',
                color: 'text.primary',
                fontWeight: 'bold',
                textAlign: 'center',
                py: 1
            }}>
                Ürün Gönderim Detayları
            </DialogTitle>
            
            <DialogContent sx={{ p: 2 }}>
                {!productTransfers && (
                    <Box display="flex" justifyContent="center" p={2}>
                        <CircularProgress />
                    </Box>
                )}

                {productTransfers && productTransfers.length === 0 && (
                    <Box display="flex" justifyContent="center" p={2}>
                        <Typography color="text.secondary">
                            Kayıt bulunamadı.
                        </Typography>
                    </Box>
                )}

                {Array.isArray(productTransfers) && productTransfers.length > 0 && (
                    <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell width={50}></TableCell>
                                    <TableCell>Gönderilen Platform</TableCell>
                                    <TableCell>Durum</TableCell>
                                    <TableCell>Oluşturma Tarihi</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {productTransfers.map((transfer, index) => (
                                    <TransferRow key={transfer.id || index} transfer={transfer} />
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ProductTransferInfoModal;